
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classroom",
      function () {
        return require("private-next-pages/classroom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/classroom"])
      });
    }
  